"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ArrowBackIosOutlined_1 = __importDefault(require("@material-ui/icons/ArrowBackIosOutlined"));
const ArrowForwardIosOutlined_1 = __importDefault(require("@material-ui/icons/ArrowForwardIosOutlined"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
/**
 * Used to render a carousel UI with content. Navigation is controled by the arrow icons.
 */
const Carousel = ({ className, startIndex, children, onIndexChange }) => {
    const carouselContentStyles = styles_1.makeStyles({
        root: {
            '& > *': {
                maxHeight: '100%',
                maxWidth: '100%',
            },
        },
    });
    const carouselContentClasses = carouselContentStyles();
    const [curIndex, setCurIndex] = react_1.useState(0);
    const [slideDirection, setSlideDirection] = react_1.useState();
    const elements = children ? (Array.isArray(children) ? children : [children]) : [];
    react_1.useEffect(() => {
        const newIndex = startIndex && startIndex > 0 && startIndex < elements.length ? startIndex : 0;
        setCurIndex(newIndex);
        onIndexChange && onIndexChange(newIndex);
    }, [startIndex, elements]);
    function goToPreviousIndex() {
        if (elements.length === 0) {
            return;
        }
        setSlideDirection('right');
        const newIndex = (curIndex + elements.length - 1) % elements.length;
        setCurIndex(newIndex);
        onIndexChange && onIndexChange(newIndex);
    }
    function goToNextIndex() {
        if (elements.length === 0) {
            return;
        }
        setSlideDirection('left');
        const newIndex = (curIndex + 1) % elements.length;
        setCurIndex(newIndex);
        onIndexChange && onIndexChange(newIndex);
    }
    return (react_1.default.createElement("div", { className: `flex justify-between items-center overflow-hidden ${className}` },
        react_1.default.createElement(core_1.IconButton, { className: "boa-1 bo-gray2", onClick: goToPreviousIndex, disabled: elements.length < 2 },
            react_1.default.createElement(ArrowBackIosOutlined_1.default, { stroke: "none" })),
        elements.length > 0 && (react_1.default.createElement("div", { className: "flex-grow-1 mh-6 h-100%" }, elements.map((child, index) => (react_1.default.createElement("div", { key: index, className: `justify-center items-center w-100% h-100% ${carouselContentClasses.root} ${index !== curIndex ? 'no-display' : 'flex'}` }, slideDirection ? (react_1.default.createElement(core_1.Slide, { key: index, in: index === curIndex, direction: slideDirection }, child)) : (child)))))),
        elements.length === 0 && react_1.default.createElement("div", null, "No content."),
        react_1.default.createElement(core_1.IconButton, { className: "boa-1 bo-gray2", onClick: goToNextIndex, disabled: elements.length < 2 },
            react_1.default.createElement(ArrowForwardIosOutlined_1.default, { stroke: "none" }))));
};
exports.default = Carousel;
